import { Component } from './component';

export type TreeItem =
  | string
  | {
      content: string;
      href?: string;
      items?: TreeItem[];
      collapsable?: boolean;
      collapsed?: boolean;
    };

export interface TreeViewProps {
  items: TreeItem[];
  onItemSelect?: (name: string) => void;
}

export class TreeView extends Component {
  public el: HTMLUListElement;

  constructor(props?: TreeViewProps) {
    super();
    this.el = document.createElement('ul');
    this.el.classList.add('tree-view');

    if (props?.items) {
      for (const item of props.items) {
        const li = this.createTreeItem(item);
        this.el.appendChild(li);
      }

      const items = this.el.querySelectorAll('li');
      for (const item of items) {
        item.addEventListener('click', (e) => {
          const allItems = this.el.querySelectorAll('li');
          for (const it of allItems) {
            it.classList.remove('active');
          }
          item.classList.add('active');
          e.stopImmediatePropagation();

          if (props.onItemSelect) {
            const link = item.querySelector('a');
            const span = item.querySelector('span');

            props.onItemSelect(link?.textContent || span?.textContent || '');
          }
        });
      }
    }
  }

  private createTreeItem(item: TreeItem): HTMLLIElement {
    const li = document.createElement('li');

    if (typeof item === 'string') {
      li.appendChild(this.getItemContent(item));
    } else {
      if (!item.items) {
        li.appendChild(this.getItemContent(item));
        return li;
      }

      const ul = document.createElement('ul');
      const content = this.getItemContent(item);

      if (item.collapsable) {
        const details = document.createElement('details');
        if (item.collapsed) {
          details.open = false;
        } else {
          details.open = true;
        }

        const summary = document.createElement('summary');
        summary.appendChild(content);
        details.appendChild(summary);
        details.appendChild(ul);
        li.appendChild(details);
      } else {
        li.appendChild(content);
        li.appendChild(ul);
      }

      for (const i of item.items) {
        const childLi = this.createTreeItem(i);
        ul.appendChild(childLi);
      }
    }

    return li;
  }

  private getItemContent(item: TreeItem): Node {
    if (typeof item === 'string') {
      const span = document.createElement('span');
      span.innerText = item;
      return span;
    }

    if (item.href) {
      const a = document.createElement('a');
      a.href = item.href;
      a.appendChild(document.createTextNode(item.content));
      return a;
    }

    const span = document.createElement('span');
    span.innerText = item.content;
    return span;
  }
}
